import { combineReducers } from "redux"
import { formType } from "./formTypeReducer"

const authReducers = combineReducers({
  formType
})

export default authReducers
